var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.contractPlanId ? _vm.$t("编辑产品") : _vm.$t("新增产品"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("保存"),
      cancelText: _vm.$t("关闭"),
      width: 800
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "code",
      label: _vm.$t("产品代码")
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品代码")
    },
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1), _c("div", {
    staticClass: "right"
  })])]), _c("a-form-model-item", {
    attrs: {
      prop: "code",
      label: _vm.$t("产品名称")
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("div", {
    staticClass: "right"
  })])]), _c("a-form-model-item", {
    attrs: {
      prop: "price",
      label: _vm.$t("保费")
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input-number", {
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))
    },
    model: {
      value: _vm.dataFrom.premium,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium", $$v);
      },
      expression: "dataFrom.premium"
    }
  })], 1), _c("div", {
    staticClass: "right"
  })])]), _c("a-form-model-item", {
    attrs: {
      prop: "paymentDeadline",
      label: _vm.$t("缴费期限")
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-radio-group", {
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.paymentDeadline2.way,
      callback: function ($$v) {
        _vm.$set(_vm.paymentDeadline2, "way", $$v);
      },
      expression: "paymentDeadline2.way"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("趸交")))]), _c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "150px"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: _vm.paymentDeadline2.way == "1" ? false : true
    },
    on: {
      change: _vm.onChange2
    },
    model: {
      value: _vm.paymentDeadline2.type,
      callback: function ($$v) {
        _vm.$set(_vm.paymentDeadline2, "type", $$v);
      },
      expression: "paymentDeadline2.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("年交")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("季交")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("月交")))]), _c("a-select-option", {
    attrs: {
      value: "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("周交")))])], 1), _c("a-input-number", {
    staticStyle: {
      width: "120px",
      "margin-left": "10px"
    },
    style: !_vm.paymentDeadlineCont ? "border:1px solid red" : "",
    attrs: {
      min: 1,
      max: 100,
      disabled: _vm.paymentDeadline2.way == 1 ? false : true,
      placeholder: _vm.$t("请输入")
    },
    on: {
      change: function ($event) {
        _vm.paymentDeadlineCont = true;
      }
    },
    model: {
      value: _vm.paymentDeadline2.value,
      callback: function ($$v) {
        _vm.$set(_vm.paymentDeadline2, "value", $$v);
      },
      expression: "paymentDeadline2.value"
    }
  })], 1)], 1)], 1), _c("div", {
    staticClass: "right"
  })])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障期限")
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px",
      "margin-right": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请选择")
    },
    on: {
      change: function ($event) {
        ;
        _vm.duration1 = "", _vm.duration2 = "", _vm.onChange3();
      }
    },
    model: {
      value: _vm.dataFrom.duration2.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.duration2, "type", $$v);
      },
      expression: "dataFrom.duration2.type"
    }
  }, _vm._l(_vm.termlist, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-input-number", {
    style: !_vm.duration1Color ? "border:1px solid red" : "",
    attrs: {
      placeholder: _vm.$t("请输入"),
      disabled: _vm.dataFrom.duration2.type == 5 ? true : false
    },
    on: {
      change: function ($event) {
        _vm.duration1Color = true;
      }
    },
    model: {
      value: _vm.duration1,
      callback: function ($$v) {
        _vm.duration1 = $$v;
      },
      expression: "duration1"
    }
  }), _vm.dataFrom.duration2.type == 2 || _vm.dataFrom.duration2.type == 4 ? _c("div", {
    staticStyle: {
      width: "80px",
      height: "1px",
      background: "#d9d9d9",
      margin: "0 10px"
    }
  }) : _vm._e(), _vm.dataFrom.duration2.type == 2 || _vm.dataFrom.duration2.type == 4 ? _c("a-input-number", {
    style: !_vm.duration2Color ? "border:1px solid red" : "",
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    on: {
      change: function ($event) {
        _vm.duration2Color = true;
      }
    },
    model: {
      value: _vm.duration2,
      callback: function ($$v) {
        _vm.duration2 = $$v;
      },
      expression: "duration2"
    }
  }) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "right"
  })])]), _c("a-form-model-item", {
    class: _vm.rightsList.length > 1 ? "listBox" : "",
    attrs: {
      label: _vm.$t("保障方案")
    }
  }, [_c("div", {
    staticClass: "list"
  }, _vm._l(_vm.rightsList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "box"
    }, [_c("div", {
      staticClass: "cont"
    }, [_c("a-input", {
      staticStyle: {
        width: "150px"
      },
      attrs: {
        placeholder: _vm.$t("保险责任"),
        maxLength: 50
      },
      on: {
        change: _vm.InputFun
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        width: "100px"
      },
      attrs: {
        placeholder: _vm.$t("保额"),
        maxLength: 50
      },
      on: {
        change: _vm.InputFun
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        placeholder: _vm.$t("责任说明（选填）"),
        maxLength: 50
      },
      on: {
        change: _vm.InputFun
      },
      model: {
        value: item.info,
        callback: function ($$v) {
          _vm.$set(item, "info", $$v);
        },
        expression: "item.info"
      }
    })], 1), _c("div", {
      staticClass: "right"
    }, [index == 0 ? _c("a-button", {
      attrs: {
        type: "add",
        disabled: _vm.addBtn
      },
      on: {
        click: _vm.addRightsFun
      }
    }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _c("a-button", {
      attrs: {
        type: "danger"
      },
      on: {
        click: function ($event) {
          return _vm.delRightsFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)]);
  }), 0)])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };